import React, { Fragment, Component } from 'react'
import { AlertModal } from 'app/common/modals/alert'
import { Close } from 'app/assets/icons'
import { colors } from 'shared/assets/styles'
import styled from 'styled-components'
import { injectIntl } from 'react-intl'
import type { IntlShape } from 'react-intl'

const { text } = colors

type Props = {
    intl: IntlShape,
    navigate: (to: string, state?: any) => void
}

type State = {
    alert: boolean
}

class HeaderModalAlert extends Component<Props, State> {
    constructor() {
        super()
        this.state = {
            alert: false
        }
    }

    goBack = () => {
        const { navigate, intl } = this.props
        this.setState({ alert: false })
        navigate(
            intl.formatMessage({
                id: 'routes.clickandcollect.catalog'
            })
        )
    }

    render() {
        const { alert } = this.state
        return (
            <Fragment>
                <CloseIconContainer
                    onClick={() =>
                        this.setState({
                            alert: true
                        })
                    }>
                    <Close size={24} color={text} />
                </CloseIconContainer>
                <AlertModal
                    alertTitleKey="clickandcollect.cart.quit.title"
                    alertContentKey="clickandcollect.cart.quit"
                    handleClose={() => this.setState({ alert: false })}
                    isOpen={alert}
                    okLabel="yes"
                    leftLabel="cancel"
                    onOkClick={this.goBack}
                    onLeftClick={() => this.setState({ alert: false })}
                />
            </Fragment>
        )
    }
}
const CloseIconContainer = styled.div`
    padding: 10px;
`

const HeaderModalAlertComponent = injectIntl(HeaderModalAlert)
export { HeaderModalAlertComponent }
